// extracted by mini-css-extract-plugin
module.exports = {"category":"CategoryName_category__-bN1M"};